import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function HowItWorksHero() {
  return <section className="relative w-full pt-20 pb-32 px-6 md:px-12 lg:px-24 overflow-hidden bg-white" data-id="element-790">
      {/* Background Image */}
      <div className="absolute top-0 right-0 pointer-events-none" style={{
      width: '100%',
      height: '800px'
    }} data-id="element-791">
        <img src="https://cdn.magicpatterns.com/uploads/kga88EcdPJUPTBaJUremGs/background_thought.png" alt="" className="absolute right-0 top-[12%] w-[100%] h-auto opacity-90" data-id="element-792" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-793">
        <div className="flex flex-col space-y-8" data-id="element-794">
          <div className="inline-flex items-center px-3 py-1 rounded-full border border-gray-200 bg-gray-50 mt-20 w-fit" data-id="element-795">
            <span className="text-xs font-medium text-gray-600 uppercase tracking-wider font-sans" data-id="element-796">
              HOW IT WORKS
            </span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold leading-[0.95] tracking-tight text-black max-w-6xl font-['Syne']" data-id="element-797">
            Ungoverned AI makes decisions for you.
            <br data-id="element-798" />
            Often,{' '}
            <span className="bg-blue-600 text-white px-3" data-id="element-799">bad ones.</span>
          </h1>

          <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-2xl font-light" data-id="element-800">
            Which regulations apply here? What terminology is prohibited? Is
            this internal-facing or external? AI makes hundreds of these calls
            based on internet averages.{' '}
            <strong className="text-black font-semibold" data-id="element-801">
              Synthia makes them based on your standards.
            </strong>
          </p>

          <div className="pt-4" data-id="element-802">
            <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 bg-[#0066FF] text-white font-['Syne'] font-bold text-sm tracking-wide uppercase hover:bg-black transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0066FF]" data-id="element-803">
              BOOK A DEMO
              <ArrowRight className="w-5 h-5" data-id="element-804" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}